import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IBillingDocument } from '@dch/billing-business-logic';
import { tap } from 'rxjs/operators';
import { ApplicationState } from 'src/app/state/reducers';
import { selectTransactionsByAccountNumber } from 'src/app/state/selectors/billing-transactions.selectors';
import { getBillExplanationType } from '../services/utils.service';
import { BillExplanationType } from '../models/extra-cost.model';
import { OnDestroyHookDirective } from '../common/hooks';
import { getBillingTransactionsRequest } from 'src/app/state/actions';
import { Router } from '@angular/router';

@Component({
  selector: 'my-bill-odb-bill-document-explanation-intro',
  templateUrl: './odb-bill-document-explanation-intro.component.html',
  standalone: false,
})
export class OdbBillDocumentExplanationIntroComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() billingDocument: IBillingDocument;
  @Input() accountNumber: string;
  billExplanationType: BillExplanationType;

  constructor(private store: Store<ApplicationState>, private router: Router) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store
        .select(selectTransactionsByAccountNumber(this.accountNumber))
        .pipe(
          tap((transactions) => {
            if (transactions && transactions.result !== null) {
              this.billExplanationType = getBillExplanationType(
                transactions.result,
                this.billingDocument
              );
            } else if (
              transactions === undefined ||
              (transactions.isFetching === false &&
                transactions.result === null &&
                transactions.hasError === false)
            ) {
              this.store.dispatch(
                getBillingTransactionsRequest(this.accountNumber)
              );
            }
          })
        )
        .subscribe()
    );
  }

  goToExplanationPage() {
    this.router.navigate(['/billing-explanation/' + this.billExplanationType]);
  }
}
